import React, { PropsWithChildren } from "react";

interface PropsType extends PropsWithChildren {}

export default function SideBarContent({ children }: PropsType) {
  return (
    <div className="grow overflow-auto">
      <div className="p-8">{children}</div>
    </div>
  );
}
